package com.example.mystybag.appCore.views

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.example.mystybag.appCore.logic.CitySelectionBottomSheetChild
import com.example.mystybag.appCore.logic.PersonalDetailsViewModel
import com.example.mystybag.appCore.logic.PhoneSelectionBottomSheetChild
import com.example.mystybag.appCore.views.components.ClientWebHeaderBar
import com.example.mystybag.appCore.views.components.WebHeaderBottomDivider
import com.example.mystybag.common.logic.DualTextInputBottomSheetChild
import com.example.mystybag.common.logic.TextInputBottomSheetChild
import com.example.mystybag.common.ui.views.BottomSheetUIView
import com.example.mystybag.common.views.CommonBottomSheetFactory
import com.example.mystybag.common.views.DualTextInputBottomSheetView
import com.example.mystybag.common.views.TextInputBottomSheetView
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.ui.theme.LocalTheme.p16

@Composable
fun PersonalDetailsWebView(viewModel: PersonalDetailsViewModel) {
    BottomSheetUIView(
        modifier = Modifier.fillMaxSize(),
        viewModel = viewModel,
        showTopBar = false,
        navigationContent = null,
        bottomSheetFactory = {
            when (it) {
                is TextInputBottomSheetChild -> TextInputBottomSheetView(it.viewModel)
                is DualTextInputBottomSheetChild -> DualTextInputBottomSheetView(it.viewModel)
                is CitySelectionBottomSheetChild -> CitySelectionBottomSheetView(it.viewModel)
                is PhoneSelectionBottomSheetChild -> PhoneSelectionBottomSheetView(it.viewModel)
                else -> CommonBottomSheetFactory(it)
            }
        }
    ) { uiState ->
        Column(modifier = Modifier.fillMaxSize()) {
            ClientWebHeaderBar(
                selectedTab = 3,
                homeTabIndex = 0,
                deliveryTabIndex = 1,
                favoritesTabIndex = 2,
                menuTabIndex = 3,
                searchCallbacks = null,
                onFilterClick = {},
                showSearchAndFilter = false,
                showBackButton = true,
                onBackClick = viewModel::onBackClick,
                centerTitle = sharedString(SR.strings.profile)
            )
            WebHeaderBottomDivider()
            Box(
                modifier = Modifier.fillMaxWidth(),
                contentAlignment = Alignment.TopCenter
            ) {
                PersonalDetailsContent(
                    uiState = uiState,
                    viewModel = viewModel,
                    modifier = Modifier
                        .width(1080.dp)
                        .verticalScroll(rememberScrollState())
                        .padding(horizontal = p16)
                )
            }
        }
    }
}
